/* eslint-disable no-console */
import { useLocation } from "react-router-dom";
import {
    ValidationBusyIcon,
    ValidationSuccessIcon,
} from "../StatusIcons/Icons";
import {useValidation} from "../validation/validation";
import {ValidationMessageTypeIcon} from "../StatusIcons/ValidationMessageTypeIcon";
import { useProjects } from "../Behaviors/projects";
import { useStore } from "../State/zustandStore";

interface Props {
    projectId?: string /* The '?' makes projectId optional */
}

export const ProductStatusAll = ({ projectId }: Props) => {
    const workspaceState = useStore().projects;
    const projId = projectId
        ? projectId
        : workspaceState.selectedProjectId;
    const {project} = useProjects(projId);
    const {
        isValidationInProgress,
        getProductValidationErrors,
        getProductValidationRestrictions,
        getProductValidationWarnings,
        getResourceValidationErrors,
    } = useValidation(projectId);
    const jobId = project?.jobId;
    const reportPage = useLocation().pathname.includes(`${projectId}`);

    console.log(`ProductStatusAll projectId=${projectId} jobId=${jobId}`);

    if (isValidationInProgress(jobId)) {
        return <ValidationBusyIcon />;
    }

    let messages = getProductValidationErrors(jobId)
        .concat(getProductValidationRestrictions(jobId))
        .concat(getProductValidationWarnings(jobId));

    if (messages?.length === 0) {
        messages = getResourceValidationErrors(jobId);
    }

    if (messages?.length === 0) {
        return <ValidationSuccessIcon />;
    }
    return (
        <div className={reportPage ? "bg-light" : "bg-light row"}>
            <table >
                <tbody>
                    {
                        messages.map(msg => {
                            return (
                                <tr key={`${msg.timeStamp}`}>
                                    <td className={"iconic"}>
                                        <ValidationMessageTypeIcon messageType={msg.messageType!} />
                                    </td>
                                    <td style={{ width: "100%" }}>
                                        {msg.message}
                                    </td>
                                </tr>
                            );
                        })
                    }
                </tbody>
            </table >
        </div>
    );
};
